import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />
          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-brightstone.webp"
            alt="Brightstone"
          />
        </p>
        <strong>
          The grand mansions and luxury shops of the wealthy elite.
        </strong>
        <p>
          <em>
            Brightstone is home to many of the{" "}
            <strong>wealthiest and most influential citizens</strong> of
            Doskvol. Its streets are broad and <strong>paved</strong>, under
            bright <strong>electric lights</strong>; its canals are sparkling
            and clean, with <strong>perfumed water</strong>; its houses are all
            of fine, pale marble blocks, rich timbers, and intricate ironworks.
            There are <strong>cultivated parks</strong> fed by radiant energy;{" "}
            <strong>lavish restaurants and cafes</strong>; jewelers, tailors,
            and other luxury shops.{" "}
            <strong>Street-side vendors are forbidden here</strong>, resulting
            in a serene, spacious atmosphere, punctuated by the occasional
            carriage or marching Bluecoat patrol.
          </em>
        </p>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-brightstone.webp"
          alt="Brightstone"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Nutshell.</strong> Grand mansions and luxury shops.
                <br />
                <strong>Scene:</strong> Elite Bluecoat patrols, arrayed in fine
                armor and gleaming gun-pikes. Wealthy citizens strolling through
                manicured parks, attended by servants. Horse-drawn coaches and
                the occasional electroplasmic carriage rumbling along the
                avenues.
                <br />
                <strong>Streets:</strong> Broad, clean, well-lit.
                <br />
                <em>
                  Silvermark Avenue, Goldcrest Avenue, Ruby Street, Sapphire
                  Street.
                </em>
                <br />
                <strong>Buildings:</strong> Pale stone mansions with lightning
                barriers, grand manor houses, lavish townhouses, opulent
                theaters and restaurants, luxury shops.
                <br />
                <strong>Factions</strong>
                <ul>
                  <li>1. Church of Ecstasy (Sanctorium)</li>
                  <li>2. The Fog Hounds (east part)</li>
                  <li>3. The Hive</li>
                  <li>4. The Circle of Flame</li>
                  <li>5. The Silver Nails</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/pages/fHMuSzkuof1d47L6-pages-c4qJcP2tfw3P3Q0O-image-8uSPuex8kqwhJgJJ.png"
                  alt="Brightstone district traits"
                />
                <br />
                <em>
                  Most engagement rolls suffer <strong>-1d</strong> due to heavy
                  Bluecoat patrols.
                </em>
                <br />
                <em>
                  Operations against the nobility in Brightstone are considered
                  on “hostile turf” for the purpose of generating{" "}
                  <strong>heat</strong>.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Brightstone Locations</h1>
        <strong>
          <u>Bowmore Bridge</u>
        </strong>
        : This massive structure of bright white stone and shimmering metal-work
        is said to be the largest bridge in the Imperium. Luxury apartments and
        shops perch all along its length from Brightstone to Whitecrown.
        <br />
        <br />
        Bowmore Club is a gambling place on the Bowmore Bridge catering to the
        high rollers of Doskvol.
        <br />
        <br />
        <strong>
          <u>The Sanctorium</u>
        </strong>
        : The chief cathedral dedicated to the Church of the Ecstasy of the
        Flesh. It’s a towering edifice of buttresses and spires, originally
        commissioned by the Emperor during his last visit to Doskvol nearly 500
        years ago.
        <br />
        <br />
        Devotees gather weekly to purify themselves in baptismal rites and
        through the ritual destruction of rogue spirits in electroplasm.
        <br />
        <br />
        The catacombs beneath contain the cremated ash of many famous and
        affluent citizens.
        <br />
        <br />
        <strong>
          <u>Silver Market</u>
        </strong>
        : A curated <strong>open-air emporium</strong> overlooking the North
        Hook channel. Named for its original use as the primary marketplace for
        silver traders, it’s now host to <strong>luxury goods vendors</strong>{" "}
        of all sorts, including rare Iruvian silks, spices from the Dagger
        Isles, horse-traders, carriage upholsterers, and rare alchemical
        distillations, including some illegal spirit essences—to which the City
        Watch turns a blind eye.
        <br />
        <br />
        <strong>
          <u>Unity Park</u>
        </strong>
        : A grand park, fountain, and roundabout featuring an enormous monument
        commemorating Imperial victory in the Unity War (or the War for Skovlan
        Independence, depending on who you talk to).
        <br />
        <br />
        Located in the middle of Brightstone.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClassesDistrictsBrightstone = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-introduction"
                    >
                      Introduction
                    </a>{" "}
                    💀
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-districts"
                    >
                      Districts
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClassesDistrictsBrightstone;
